import { NavigationGuardNext, Route } from 'vue-router'
import store from '@/store'

async function checkRouteQueryGuard(to: Route, from: Route, next: NavigationGuardNext) {
  // eslint-disable-next-line no-restricted-globals
  if (to.query.branch_id && !isNaN(parseInt(to.query.branch_id.toString(), 10))) {
    await store.dispatch('branches/SET_BRANCH', parseInt(to.query.branch_id.toString(), 10))
  }

  return next()
}

export default checkRouteQueryGuard
